(function(){
    angular.module('tmx-app').factory('BulkReassignmentService', ['$mdMedia','tmxResource',
        function($mdMedia,tmxResource){

            var BulkReassignment = tmxResource("LoanApplication/GetAllApplications");

            var menulinkHtml = "";
            menulinkHtml = menulinkHtml + "<md-menu flex='none' ng-if='BulkReassignmentCtrl.showBulkAssignment'  class='menu-list-item' md-offset='-60 60'> ";
            menulinkHtml = menulinkHtml + "    <md-button style='right:-5px !important;'  class='menu-list-item-grid' ng-click='$mdOpenMenu()' > ";
            menulinkHtml = menulinkHtml + "        <md-icon class='menu-list-item material-icons margin-right-24'>more_vert</md-icon> ";
            menulinkHtml = menulinkHtml + "    </md-button> ";
            menulinkHtml = menulinkHtml + "    <md-menu-content width='2'> ";
            menulinkHtml = menulinkHtml + "        <md-menu-item> ";
            menulinkHtml = menulinkHtml + "            <md-button ng-disabled='!BulkReassignmentCtrl.assignPermission' aria-label='del' class='tmxMin' ng-click='BulkReassignmentCtrl.applicationReassign()'> ";
            menulinkHtml = menulinkHtml + "                 <md-icon class='md-accent material-icons menu-list-item'>check</md-icon> {{\"Reassign\"|translate}}";
            menulinkHtml = menulinkHtml + "            </md-button> ";
            menulinkHtml = menulinkHtml + "        </md-menu-item> ";
            menulinkHtml = menulinkHtml + "    </md-menu-content> ";
            menulinkHtml = menulinkHtml + "</md-menu>";


//  <md-checkbox style='top: 10px;left:10px;' ng-change='BulkReassignmentCtrl.allApplicationChecked(check)' ng-model='check' />
            BulkReassignment.gridColumn = [
                {   
                    width: $mdMedia('gt-sm') ? '6%' : '150px',
                    headerTemplate:"",
                    template: "<md-checkbox style='top: 10px;' ng-change='BulkReassignmentCtrl.applicationChecked(dataItem)' ng-model='dataItem.Selected' />"
                },
                {
                    field:"ApplicationNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('ApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"ApplicationNumber\")' ></i></span>"

                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "alpha",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "{{dataItem.CustomerName}}"
                },
                {
                    field:"ProductName",
                    title:"ProductName",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName | cut:true:6 }}</span><md-tooltip md-direction='top'>{{dataItem.ProductName}}</md-tooltip>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('ProductName')}\" >{{'ProductName' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"BranchName",
                    title:"BranchName ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"InboxUser",
                    title:"InboxUser",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"InboxUser\")' ></i></span>"
                },
                {
                    field:"Creator",
                    title:"Creator",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"Creator\")' ></i></span>"
                },
                {
                    field:"ApplicationDate",
                    title:"ApplicationDate",
                    type: "text",
                    search: true,                    
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('ApplicationDate')}\" >{{'ApplicationDate' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"ApplicationDate\")' ></i></span>"
                },
                {
                    field:"CurrentState",
                    title:"CurrentState",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('CurrentState')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"CurrentState\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BulkReassignmentCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='BulkReassignmentCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
                },
                {
                    width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<md-menu flex='none' class='menu-list-item'><md-button ng-click='$mdOpenMenu()'><md-icon class='menu-list-item material-icons  margin-right-24'>more_vert</md-icon></md-button><md-menu-content width='2'><md-menu-item>"+
        "<md-button ng-disabled='!BulkReassignmentCtrl.assignPermission'  aria-label='del' class='tmxMin' ng-click='BulkReassignmentCtrl.applicationReassign()'> "+
        "<md-icon class='md-accent material-icons menu-list-item'>check</md-icon> {{\"Reassign\"|translate}}"+
        "</md-button> "+
        "</md-menu-item></md-menu-content></md-menu>",
                    headerTemplate: menulinkHtml,
                }

            ];
 

            BulkReassignment.columns = angular.copy(BulkReassignment.gridColumn);
            return BulkReassignment;

        }]);
})();